import { getters } from "@shared/template/StoreTemplates/FilterStoreTemplate"

export default {
  getIsEditing: state => state.isEditing,
  getCoverageToEditId: state => state.coverageToEditId,
  getAreas: state => state.areas,
  ...getters
}
